import React, { Component } from 'react';
import PropTypes from 'prop-types';
import dateFormat from 'dateformat';

class FuelOrderDetails extends Component {
  constructor(props) {
    super(props);

    this.state = {
      groupTotal: 0,
    };

    this.calculateTotal = this.calculateTotal.bind(this);
  }

  componentWillMount() {
    this.calculateTotal();
  }

  calculateTotal() {
    let total = 0;
    const { fuelOrders } = this.props.fuelMeter;
    if (fuelOrders && fuelOrders.length > 0) {
      total += fuelOrders[fuelOrders.length - 1].finalMeterQuantity;
      total -= fuelOrders[0].initialMeterQuantity;
    }
    this.setState({ groupTotal: total });
  }

  renderFuelOrder(fuelOrder) {
    const timeMask = 'h:MM:ss TT Z';
    return (
      <span key={fuelOrder.id} className="order-item">
        {/* <div className="tail-number"> */}
        <div className="report-col-truck">
          {fuelOrder.order.tailNumber ? fuelOrder.order.tailNumber : 'N/A'}
        </div>
        <div className="report-col-plane-type">
          {fuelOrder.order.aircraft ? 'X' : '\u00A0' }
        </div>
        <div className="report-col-plane-type">
          {fuelOrder.order.aircraft ? '\u00A0' : 'X' }
        </div>
        {/* <div className="initial-meter-quantity"> */}
        <div className="report-col-truck">
          {parseFloat(fuelOrder.initialMeterQuantity).toFixed(1)}
        </div>
        {/* <div className="final-meter-quantity"> */}
        <div className="report-col-truck">
          {parseFloat(fuelOrder.finalMeterQuantity).toFixed(1)}
        </div>
        {/* <div className="quantity"> */}
        <div className="report-col-truck">
          {parseFloat(fuelOrder.totalQuantityAdded).toFixed(1) }
        </div>
        {/* <div className="fulfilled-at"> */}
        <div className="report-col-truck">
          {dateFormat(fuelOrder.order.fulfilledAt, timeMask) }
        </div>
        {/* <div className="initial"> */}
        <div className="report-col-truck">
          -
        </div>
        {/* <div className="invoice-number"> */}
        <div className="report-col-truck">
          {fuelOrder.order.invoiceNumber ? fuelOrder.order.invoiceNumber : 'N/A'}
        </div>
        <div className="clear" />
      </span>
    )
  }

  renderOrders() {
    return (
      <span>
        {this.props.fuelMeter.fuelOrders.map(fuelOrder =>
          this.renderFuelOrder(fuelOrder))
        }
      </span>
    )
  }
  render() {
    return (
      <span>
        <h6>{this.props.fuelMeter.name} </h6>
        {this.renderOrders()}
        <div className="total right">
          <hr />
          <strong>{this.props.fuelMeter.name} Total: {parseFloat(this.state.groupTotal).toFixed(1)} Gal</strong>
        </div>
        <div className="clear" />
      </span>
    );
  }
}

FuelOrderDetails.propTypes = {
  fuelMeter: PropTypes.shape({}).isRequired,
  // order: PropTypes.shape({
  //   orderNumber: PropTypes.string.isRequired,
  //   invoiceNumber: PropTypes.string.isRequired,
  //   closedAt: PropTypes.instanceOf(Date).isRequired,
  //   fulfilledAt: PropTypes.instanceOf(Date).isRequired,
  //   customerName: PropTypes.string.isRequired,
  //   tailNumber: PropTypes.string.isRequired,
  //   fuelOrders: PropTypes.shape({}).isRequired,
  // }).isRequired,
};

export default FuelOrderDetails;



// WEBPACK FOOTER //
// ./src/Containers/Reports/FuelTrucks/FuelTruckMeterDetails.js